// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".emarsysButtons[data-v-10dcc86d]{border:none;background:none}.emarsysButtons[data-v-10dcc86d]:hover{color:#2a4a58}.emarsysButtonDisabled[data-v-10dcc86d]{border:none;background:none;color:#dee2e6 !important}.emarsysButtonDisabled[data-v-10dcc86d]:hover{color:#dee2e6 !important;cursor:initial}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
